import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Invitation from './Invitation';

const Invitations = ({ invitations, actions, onAction, classes }) => {
    const invitationItems = invitations.map(invitation => (
        <Invitation
            key={invitation.id}
            invitation={invitation}
            actions={actions}
            onAction={onAction}
        />
    ));
    return <div className={classes.wrapper}>{invitationItems}</div>;
};

Invitations.propTypes = {
    invitations: PropTypes.array.isRequired,
    actions: PropTypes.array.isRequired,
    onAction: PropTypes.func.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: spacing.unit * 5,
    },
});

export default injectSheet(style)(Invitations);



// WEBPACK FOOTER //
// ./src/components/invitations/Invitations.js